import { createContext } from 'react';

type Context = { showModal: Function | undefined; closeModal: Function | undefined };

const ModalContext = createContext<Context>({ showModal: undefined, closeModal: undefined });

export default ModalContext;
